import { areDescriptionsEqual } from "../helpers";

export type ProcessStepForComparison = {
  description?: string | null | undefined;
  industrialProcess?: string | undefined;
};

export const areProcessStepsEquals = (
  a: ProcessStepForComparison,
  b: ProcessStepForComparison,
): boolean => {
  const aDesc = a.description ?? undefined;
  const bDesc = b.description ?? undefined;

  if (a.industrialProcess !== b.industrialProcess) {
    return false;
  }

  if (aDesc && bDesc) {
    return areDescriptionsEqual(aDesc, bDesc);
  }

  if (!aDesc && !bDesc) {
    return true;
  }

  return false;
};
